import ShieldAddOn from "../Player/pickupAddOns/shields.js";
import TurretAddOn from "../Player/pickupAddOns/turret.js";

import { GameConfig } from "./GameConfig.js";

export const PickupAbility = {
  SHIELD: new ShieldAddOn(),
  TURRET: new TurretAddOn(),
};

export const PickupConfig = {
  SPEED: -10,
  INITIAL_X_POS_PX: GameConfig.CANVAS_WIDTH + 100,
  Shield: {
    IMG_SRC: "./assets/player/pickups/round-shield.png",
    SPRITE_WIDTH: 32,
    SPRITE_HEIGHT: 32,
    TOTAL_TIME_MS: 25000,
  },
  Turret: {
    IMG_SRC: "./assets/player/pickups/SpaceGun-UI.png",
    SPRITE_WIDTH: 32,
    SPRITE_HEIGHT: 32,
    TOTAL_TIME_MS: 10000,
  },
};
